import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import QqCircleFilledSvg from "@ant-design/icons-svg/es/asn/QqCircleFilled";
import AntdIcon from "../components/AntdIcon";
var QqCircleFilled = function QqCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QqCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  QqCircleFilled.displayName = 'QqCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(QqCircleFilled);